module.exports = __webpack_public_path__ + "img/blood_pressure_white.b3c8888d.svg";